<script lang="ts">
    import { createEventDispatcher } from 'svelte'
    import { BLOCK_DEFINITIONS, getBlockCategories } from '../blocks/block-registry'
    import BlockPaletteItem from './block-palette-item.svelte'

    const dispatch = createEventDispatcher()
    const categories = getBlockCategories()

    function onAdd(blockType: string) {
        dispatch('add', { blockType })
    }
</script>

<aside class="palette scroll-dark">
    <div class="palette-header">
        <p>Arraste ou clique para adicionar</p>
    </div>

    <div class="palette-body">
        {#each categories as category}
            <div class="palette-category">
                <span class="category-title">{category}</span>
                <div class="category-items">
                    {#each BLOCK_DEFINITIONS.filter((d) => d.category === category && !d.hidden) as definition}
                        <BlockPaletteItem {definition} on:add={(e) => onAdd(e.detail.blockType)} />
                    {/each}
                </div>
            </div>
        {/each}
    </div>
</aside>

<style>
    .palette {
        width: 280px;
        flex-shrink: 0;
        position: sticky;
        top: 16px;
        max-height: calc(100vh - 104px);
        margin: 16px 32px 16px 16px;
        background: #1e1e1e;

        border: 1px solid #2d2d2d;
        border-radius: 12px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
        padding: 20px 16px;
        overflow-y: auto;
    }
    .palette-header p {
        font-size: 0.78rem;
        color: #555;
        margin: 0 0 9px;
        text-align: center;
    }
    .palette-category {
        margin-bottom: 18px;
    }
    .category-title {
        display: block;
        font-size: 0.72rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;

        color: #444;
        margin-bottom: 8px;
    }
    .category-items {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    @media (max-width: 900px) {
        .palette {
            width: 100%;
            position: static;
            max-height: none;
            margin: 0;
            border: none;
            border-radius: 0;
            box-shadow: none;
            border-bottom: 1px solid #ecedf0;
        }
        .category-items {
            flex-direction: row;
            flex-wrap: wrap;
        }
        .category-items :global(.palette-item) {
            width: auto;
        }
    }

    /* ───── tema escuro ───── */
    :global(.theme_light) .palette {
        background: #fff;
        border-color: #ecedf0;
    }
    :global(.theme_light) .palette-header p {
        color: #868e96;
    }
    :global(.theme_light) .category-title {
        color: #adb5bd;
    }
</style>
